import { createSelector } from '@reduxjs/toolkit';
import { functionsNotDeleted } from 'src/store/selectors';
import type { FunctionViewModel } from '@trinnvis/dabih-api-client';
import { functionIds } from 'src/store/selectors/functions/function-ids';
import { sortByArrayAndField } from 'src/store/selectors/functions/sort-by-array-and-field';

export const functionsByRank = createSelector(functionsNotDeleted, function (functions): FunctionViewModel[] {
  const idArray: number[] = Object.values(functionIds);
  return sortByArrayAndField(functions, idArray, 'templateId', 'name', functionIds.common);
});

export const functionUuidsByRank = createSelector(functionsNotDeleted, function (functions): string[] {
  const result: string[] = [];
  const idArray: number[] = Object.values(functionIds);
  idArray.forEach((id) => {
    const func = functions.find((f) => f.mainTemplateId === id);
    if (func) {
      result.push(func.uuid);
    }
  });
  return result;
});
